import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

/** Prefija todos los titulos con "KeyStoreMan | ". */
@Injectable({ providedIn: 'root' })
export class TitleStrategyService extends TitleStrategy {
  private readonly title = inject(Title);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const title = this.buildTitle(snapshot);
    this.title.setTitle(title ? `KeyStoreMan | ${title}` : 'KeyStoreMan | Console');
  }
}
